import { Image } from '@chakra-ui/react';

import { ThemeIcon, ThemeIconProps } from '../../components';
import LightLogo from './assets/invest_dark.svg';
import DarkLogo from './assets/invest_light.svg';

function LightIcon(): JSX.Element {
  return <Image alt="All Invest" maxH="100%" src={LightLogo} />;
}

function DarkIcon(): JSX.Element {
  return <Image alt="All Invest" maxH="100%" src={DarkLogo} />;
}

export function Icon({ ...props }: ThemeIconProps): JSX.Element {
  return <ThemeIcon darkIcon={<DarkIcon />} lightIcon={<LightIcon />} {...props} />;
}
